<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.50024 13.23C10.2658 13.5857 11.1043 13.8003 12.0002 13.8003C12.8961 13.8003 13.738 13.5857 14.5002 13.23V15.0005C14.5003 15.0219 14.5035 15.0432 14.5061 15.064C13.6408 15.2841 13.0002 16.0666 13.0002 17.0005V18.0005H14.0002V17.0005C14.0002 16.4482 14.448 16.0005 15.0002 16.0005C15.5524 16.0006 16.0002 16.4483 16.0002 17.0005V18.0005H17.0002V17.0005C17.0002 16.0664 16.3591 15.2839 15.4934 15.064C15.4961 15.0432 15.5002 15.022 15.5002 15.0005V13.2446C17.5916 13.5456 19.2004 15.3457 19.2004 17.52V18.6001C19.2004 19.5938 18.3934 20.3999 17.3997 20.3999H6.59985C5.60619 20.3998 4.80005 19.5938 4.80005 18.6001V17.52C4.80009 15.3455 6.40869 13.5455 8.50024 13.2446V15.6353C8.2016 15.8082 8.00024 16.1305 8.00024 16.5005C8.00046 17.0526 8.44809 17.5005 9.00024 17.5005C9.55231 17.5004 10 17.0525 10.0002 16.5005C10.0002 16.1307 9.79874 15.8083 9.50024 15.6353V13.23ZM12.0002 3.6001C14.3214 3.6002 16.2004 5.47911 16.2004 7.80029C16.2003 10.1214 14.3213 12.0004 12.0002 12.0005C9.67906 12.0005 7.80015 10.1215 7.80005 7.80029C7.80005 5.47904 9.67899 3.6001 12.0002 3.6001Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#FAFAFA'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
}
</script>
